import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 10px;
  background: ${({ theme }) => theme.colors.lighterBackground};
  border-radius: 0.375em;
  padding: 16px 24px 24px 24px;
  margin: 12px 8px 24px 0px;
  header {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 12px;
    img {
      width: 28px;
      margin-right: 8px;
    }
    div {
      font-size: 18px;
      font-weight: bold;
    }
  }
  > div {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 12px 0;
    gap: 64px;

    @media(max-width: 500px) {
      flex-direction: column;
      /* align-items: flex-start; */
      gap: 12px;
    }

    > div {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 12px;
    }

    > div.fullWidth {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      gap: 12px;
      width: 100%;
    }
  }
`;
